import React from "react";
import ReactDOM from "react-dom";
import { Root } from "./components";

ReactDOM.render(<Root />, document.getElementById("root"));
